import React from 'react';

import { FormikProps, connect } from 'formik';
import _debounce from 'lodash/debounce';
import isEqual from 'react-fast-compare';

export interface Props {
  debounce?: number;
}

interface ConnectedProps extends Props {
  formik: FormikProps<{}>;
}

class FormikAutoSubmitter extends React.Component<ConnectedProps> {
  static defaultProps = {
    debounce: 500,
  };

  submitForm = _debounce((formik: FormikProps<{}>) => {
    formik.handleSubmit();
  }, this.props.debounce); // eslint-disable-line react/destructuring-assignment

  componentDidUpdate(prevProps: ConnectedProps) {
    const { formik } = this.props;
    if (!isEqual(prevProps.formik.values, formik.values)) {
      this.submitForm(formik);
    }
  }

  componentWillUnmount() {
    this.submitForm.cancel();
  }

  render(): null {
    return null;
  }
}

export default connect<Props, {}>(FormikAutoSubmitter);
